module.exports = __webpack_public_path__ + "media/images/village/banner-business-90afca15458bb69460653c52e17b8d93.jpg";